module.exports = __webpack_public_path__ + "static/img/ping.f300665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ping.png
// module id = tBgp
// module chunks = 4